import React from 'react'
import { Segment, Header, Icon, Divider } from "semantic-ui-react"
import SwitchRouter from 'components/SwitchRouter'
import { Route } from 'react-router-dom'
import Formulario from './Formulario'
import DadosTurno from './DadosTurno'
import PageHeaderRest from 'components/restaurante/PageHeadeRest'

export default function CartaoXCaixa({ match: { path } }) {

    return (
        <div className='page-content'>
            <PageHeaderRest />
            <Segment className='subcontent'>
                <div className="row mx-0">
                    <div className="col">
                        <Header as='h3'>
                            <Icon.Group size='big'>
                                <Icon name='file alternate outline' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Conciliação de Cartão x Caixa <Header.Subheader className='secondary-color'>Relatório</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>
                <Divider className='mt-2 custom-divider darken' fitted />
                <div className="row flex-grow-1 flex-column">
                    <SwitchRouter>
                        <Route exact path={`${path}`} render={props => <Formulario {...props} path={path} />} />
                        <Route exact path={`${path}/turno`} render={props => <DadosTurno {...props} path={path} />} />
                    </SwitchRouter>
                </div>
            </Segment>
        </div>
    )
}